import type { Ref, RefCallback } from 'react';

/** Combines refs so one element can feed several (e.g. a cloned child's own ref and ours). */
export function mergeRefs<T>(...refs: Array<Ref<T> | undefined>): RefCallback<T> {
  return (value) => {
    for (const ref of refs) {
      if (!ref) continue;
      if (typeof ref === 'function') ref(value);
      else (ref as { current: T | null }).current = value;
    }
  };
}
